import React, { useEffect, useRef, useState } from 'react';
import './MintStepWrapper.scss';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { useCosmos } from '../../helpers/cosmosHelper';
import Address from '../Address';

const MintStepWrapper = ({ children }) => {
  const [{user}] = useGlobalState()
  const [{ cosmosLogout }] = useCosmos();
  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const firstVideoRef = useRef(null);
  const address = user?.xionAddress?.substr(0, 5) + '…' + user?.xionAddress?.substr(-4);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVideoVisible(true);
      if (firstVideoRef.current) {
        firstVideoRef.current.play().catch((err) => {
          console.warn('Autoplay blocked:', err);
        });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className='mint_step_wrapper'>
      {isVideoVisible ? (
        <video
          ref={firstVideoRef}
          preload='auto'
          muted
          autoPlay
          loop
          playsInline
          className='background-video'
        >
          <source src='https://d2kqzc4rviquge.cloudfront.net/public/xion-loop.mp4' type='video/mp4' />
        </video>
      ) : (
        <div className='black-screen'></div> // Placeholder for black screen
      )}

      <div className={`mint_step_wrapper_content`}>{children}</div>
      <div className='mint_step_bottom'>
        <p className='logged_in'>Logged in with <Address a={user?.xionAddress} redirect={false} /></p>
        <p className='logout_button' onClick={cosmosLogout}>Logout</p>
      </div>
    </div>
  );
};

export default MintStepWrapper;
